import React from "react";
import { useState, useEffect } from "react";
import "./Delcomps.css";

import Button from "react-bootstrap/Button";

import axios from "axios";

export default function Delcomps() {
  const [savedid, fetchsavedid] = useState([]);

  const [sitenmval, setsitenmval] = useState();
  const [foyertable, setfoyertable] = useState([]);
  const [livingtable, setlivingtable] = useState([]);
  const [diningtable, setdiningtable] = useState([]);
  const [bedroomtable, setbedroomtable] = useState([]);
  const [showerroomtable, setshowerroomtable] = useState([]);
  const [kicthentable, setkicthentable] = useState([]);

  const [temptable, settemptable] = useState([]);
  const [othertable, setothertable] = useState([]);
  const [foyertotal, setfoyertotal] = useState(0);
  const [livingtotal, setlivingtotal] = useState(0);
  const [diningtotal, setdiningtotal] = useState(0);
  const [bedroomtotal, setbedroomtotal] = useState(0);
  const [showerroomtotal, setshowerroomtotal] = useState(0);
  const [kicthentotal, setkicthentotal] = useState(0);

  const [sno, setsno] = useState(0);
  const [othertotal, setothertotal] = useState(0);

  const stateOptions = savedid.reverse().map((item, i) => ({
    key: i,
    text: item.invoiceid,
    value: item.invoiceid,
  }));

  const getsavedid = () => {
    let url = "https://api.dremerz.net/api/savedinvoiceid/";

    fetch(url)
      .then((res) => res.json())
      .then((res) => {
        fetchsavedid(res);
        console.error(res);
      });
  };

  const deletedata = () => {
  
  };
  const getBird = (event, { value }) => {
    console.log(value);
    let bird_name = event.target.textContent;
    console.log(bird_name);
    setsitenmval(bird_name);
  };

  useEffect(() => {
    getsavedid();
  }, []);
  return (
    <>
      {/* <div>
        <table className="ucaltab">
          <tr className="uctr">
            <td className="ucaltb2"> Site Name : </td>
            <td className="ucaltb2">
            
              <Dropdown
                className="selectcomp"
                placeholder="State"
                search
                selection
                options={stateOptions}
                onChange={getBird}
              />
            </td>
          </tr>
          <tr>
            <td> </td>
            <td>
              <br />
              <Button
                onClick={() => {
                  try {
                    fetch(
                      "https://api.dremerz.net/api/savedinvoice/?invoiceid=" +
                        sitenmval +
                        "&tabname=foyer"
                    )
                      .then((res) => res.json())
                      .then((res) => {
                        setfoyertable(res);
                        console.error(res);
                        // console.warn(foyertable[0].total[0]);
                      });

                    //
                    fetch(
                      "https://api.dremerz.net/api/savedinvoice/?invoiceid=" +
                        sitenmval +
                        "&tabname=living"
                    )
                      .then((res) => res.json())
                      .then((res) => {
                        setlivingtable(res);
                        console.error(res);
                      });
                    //
                    fetch(
                      "https://api.dremerz.net/api/savedinvoice/?invoiceid=" +
                        sitenmval +
                        "&tabname=dining"
                    )
                      .then((res) => res.json())
                      .then((res) => {
                        setdiningtable(res);
                        console.error(res);
                      });
                    //
                    fetch(
                      "https://api.dremerz.net/api/savedinvoice/?invoiceid=" +
                        sitenmval +
                        "&tabname=showerroom"
                    )
                      .then((res) => res.json())
                      .then((res) => {
                        setshowerroomtable(res);
                        console.error(res);
                      });
                    //
                    fetch(
                      "https://api.dremerz.net/api/savedinvoice/?invoiceid=" +
                        sitenmval +
                        "&tabname=bedroom"
                    )
                      .then((res) => res.json())
                      .then((res) => {
                        setbedroomtable(res);
                        console.error(res);
                      });
                    //
                    fetch(
                      "https://api.dremerz.net/api/savedinvoice/?invoiceid=" +
                        sitenmval +
                        "&tabname=kicthen"
                    )
                      .then((res) => res.json())
                      .then((res) => {
                        setkicthentable(res);
                        console.error(res);
                      });
                    //
                    fetch(
                      "https://api.dremerz.net/api/savedinvoice/?invoiceid=" +
                        sitenmval +
                        "&tabname=other"
                    )
                      .then((res) => res.json())
                      .then((res) => {
                        setothertable(res);
                        console.error(res);
                      });
                    //
                   
                         
                          for (let i = 0; i < foyertable.length; i++) {
                            axios.delete(
                              "https://api.dremerz.net/api/savedinvoiceid/" +
                                foyertable[i].id +
                                "/"
                            );
                          }
                          for (let i = 0; i < livingtable.length; i++) {
                            axios.delete(
                              "https://api.dremerz.net/api/savedinvoiceid/" +
                                foyertable[i].id +
                                "/"
                            );
                          }
                          for (let i = 0; i < diningtable.length; i++) {
                            axios.delete(
                              "https://api.dremerz.net/api/savedinvoiceid/" +
                                foyertable[i].id +
                                "/"
                            );
                          }
                          for (let i = 0; i < showerroomtable.length; i++) {
                            axios.delete(
                              "https://api.dremerz.net/api/savedinvoiceid/" +
                                foyertable[i].id +
                                "/"
                            );
                          }
                          for (let i = 0; i < kicthentable.length; i++) {
                            axios.delete(
                              "https://api.dremerz.net/api/savedinvoiceid/" +
                                foyertable[i].id +
                                "/"
                            );
                          }
                          for (let i = 0; i < bedroomtable.length; i++) {
                            axios.delete(
                              "https://api.dremerz.net/api/savedinvoiceid/" +
                                foyertable[i].id +
                                "/"
                            );
                          }
                          for (let i = 0; i < othertable.length; i++) 
                          axios.delete(
                            "https://api.dremerz.net/api/savedinvoiceid/" +
                              foyertable[i].id +
                              "/"
                          );
                          alert ("Done..")
                         
                  } catch {
                    alert("Error Occured");
                  }
                }}

                //
              >
                Delete Data
              </Button>
            </td>
          </tr>
        </table>
      </div> */}
      <div className="delcomps-main">
        <table className="ucaltab">
          <tr className="uctr">
            <td className="ucaltb1">NO</td>
            <td className="ucaltb1">INVOICE ID</td>
            <td className="ucaltb123">ACTIONS</td>
          </tr>

          {savedid.map((input, index) => {
            return (
              <tr className="uctr">
                <td className="ucaltb2">{index + 1}</td>

                <td className="ucaltb2">{input.invoiceid}</td>

                <td className="ucaltb2">
                  <Button
                    onClick={() => {
                      try {
                        axios
                          .delete(
                            "https://api.dremerz.net/api/savedinvoiceid/" +
                              input.id +
                              "/"
                          )
                          .then(() => {
                            alert("Delete successful");
                            getsavedid();
                          });
                      } catch {
                        alert("Error Occured");
                      }
                    }}
                  >
                    Delete Title
                  </Button>
                </td>
              </tr>
            );
          })}

          <tr className="uctr">
            <td className="ucaltb3"></td>
            <td className="ucaltb3"></td>
            <td className="ucaltb3"></td>
          </tr>
        </table>
      </div>
    </>
  );
}
